import React from 'react';
import { getAllShortUrls } from '../utils/clubSlugUtils';

function ClubUrlTest() {
  const shortUrls = getAllShortUrls();
  
  return (
    <div style={{ padding: '2rem', fontFamily: 'monospace' }}>
      <h1>Club Short URLs Test Page</h1>
      <p>Total clubs: {shortUrls.length}</p>
      
      <div style={{ marginTop: '2rem' }}>
        <h2>All Short URLs:</h2>
        <table style={{ borderCollapse: 'collapse', width: '100%' }}>
          <thead>
            <tr style={{ backgroundColor: '#f5f5f5' }}>
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Short URL</th>
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Club Name</th>
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>City</th>
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Original Route</th>
            </tr>
          </thead>
          <tbody>
            {shortUrls.map((club, index) => (
              <tr key={index}>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                  <a 
                    href={club.shortUrl} 
                    style={{ color: '#4A90E2', textDecoration: 'none' }}
                    onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                    onMouseOut={(e) => e.target.style.textDecoration = 'none'}
                  >
                    clubsta.co{club.shortUrl}
                  </a>
                </td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{club.title}</td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{club.city}</td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                  <code style={{ fontSize: '12px', color: '#666' }}>{club.originalRoute}</code>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      <div style={{ marginTop: '2rem', backgroundColor: '#f9f9f9', padding: '1rem', borderRadius: '4px' }}>
        <h3>Examples:</h3>
        <ul>
          <li><strong>clubsta.co/fatboysrunclub</strong> → unique club names get simple URLs</li>
          <li><strong>clubsta.co/santabarbararunclub/santabarbara</strong> → different cities get club/city format</li>
          <li><strong>clubsta.co/santabarbararunclub/santabarbara/1</strong> → identical names in same city get numbers</li>
          <li><strong>clubsta.co/santabarbararunclub/santabarbara/2</strong> → second club with same name</li>
        </ul>
        <p><strong>Note:</strong> This elegant system handles all duplicate scenarios while keeping URLs clean and Instagram-bio friendly!</p>
      </div>
    </div>
  );
}

export default ClubUrlTest; 